import { RadioButtonWithLabelGroupWidget, TextFieldWidget,TextInputType } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { cssClass } from '~src/style';

const passwordTextBoxClassname = cssClass('edit-connection', 'row', {
  width: '100%'
});

export type EditConnectionDialogEmbeddedToggleProps = Readonly<{
  isPasswordEmbedded: boolean;
  handleToggleChange: (isPasswordEmbedded: boolean) => void;
  password: string | undefined;
  handlePasswordChange: (newPassword: string) => void;
}>;

export function EditConnectionDialogEmbeddedPasswordInput(props: EditConnectionDialogEmbeddedToggleProps) {
  return (
    <div className={passwordTextBoxClassname} style={{ paddingTop: '24px' }} >
      <TextFieldWidget
        className={passwordTextBoxClassname}
        label={Messages.changeConnectionPassword()}
        onChange={e => props.handlePasswordChange(e.target.value)}
        testId={'edit-conn-password'}
        data-tb-test-id='edit-conn-password'
        value={props.password}
        type={TextInputType.Password}
        style={{ width: '100%' }}
        kind='outline'
      />
    </div>
  );
}


export function EditConnectionDialogEmbeddedToggle(props: EditConnectionDialogEmbeddedToggleProps) {
  return (
    <>
      <RadioButtonWithLabelGroupWidget
        style={{ paddingTop: '24px' }}
        label={Messages.password()}
        buttonList={[
          {
            label: Messages.embeddedPasswordPromptUser(),
            testId: 'edit-conn-prompt',
            value: false,
          },
          {
            label: Messages.embeddedPasswordEmbedInConnection(),
            testId: 'edit-conn-embed',
            value: true,
          },
        ]}
        checkedIndex={props.isPasswordEmbedded ? 1 : 0}
        handleChange={(value) => props.handleToggleChange(value)}
        data-tb-test-id='edit-conn-password-toggle'
      />
    </>
  );
}
